import { Injectable } from '@angular/core';
import { GoodsModel } from 'src/models/goods.model';
import { GoodsGroupModel } from 'src/models/goodsgroup.model';
import { SettingModel } from 'src/models/setting.model';
import { ShareModel } from 'src/models/share.model';
import { TableModel } from 'src/models/table.model';
import { UserModel } from 'src/models/user.model';
import { FactorModel } from 'src/models/factor.model';
import { LocalStoreManager } from '../services/local-store-manager.service';

import { RestApiService } from 'src/services/rest-api.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StateEnum } from '../models/enum/state.enum';
import { SourceProgramEnum } from '../models/enum/sourceprogram.enum';
import { FormBuilder} from '@angular/forms';
import { ThemeEnum } from 'src/models/enum/theme.enum';
import { ActivatedRoute, Router, RouterLinkActive, Routes } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {
  public goodsGroup: GoodsGroupModel[];
  public order: GoodsModel[];
  public setting: SettingModel;
  public sharemodel: ShareModel;
  public filterTableList: TableModel[];
  public tableList: TableModel[];
  public orderTable: TableModel;
  public loginuser: UserModel;
  public openFactor: FactorModel;
  public waiterFactor: FactorModel[];
  public waiterOrder: GoodsModel[];
  //public imageUrls: (string | IImage)[];
  public imageUrls: any[];
  public lastUrl: string;
  public validations_form: any;
  public formBuilder: FormBuilder;
  public digitalmenuFactorCount: Number;
  public selectedTableGroupIndex: number;
  public digitalmenuTableId: number;
  public hasSwitchTabIndex: boolean;
  public isClub: boolean;
  public tableId: string;
  public BranchCode: number;
  public currentTheme: string;
  public selectedGroupIndex?: number;
  public selectedtab: number = 0;
  
  navLinks = [];
  
  constructor(
    public api: RestApiService<any>,
    private cache: LocalStoreManager,
    private storage: LocalStoreManager,
    private route: ActivatedRoute,
    public router: Router,
  ) {
  }
  ngOnInit() {
    this.navLinks = (
      this.route.routeConfig && this.route.routeConfig.children ?
      this.buildNavItems(this.route.routeConfig.children) :
      []
    );
  }

  buildNavItems(routes: Routes) {
    return (routes)
      .filter(route => route.data)
      .map(({ path = '', data }) => ({
        path: path,
        label: data.label,
        icon: data.icon
      }));
  }

  isLinkActive(rla: RouterLinkActive): boolean {
    const routerLink = rla.linksWithHrefs.first;
    
    return this.router.isActive(routerLink.urlTree, false);
  }
  
  public goodsGroupList(): Observable<GoodsGroupModel[]> {
    return this.api.getEntity<GoodsGroupModel[]>('GoodsGroupList').pipe(
      map((res: GoodsGroupModel[]) => {
        this.goodsGroup = res;
        return this.goodsGroup;
      }),
      catchError((err) => {
        return of(null);
      }));
  }
  public clearData() {
    this.goodsGroup = [];
    this.order = [];
    this.openFactor = null;
    this.waiterFactor = [];
    this.waiterOrder = [];
  }
  // public getSetting(): Observable<SettingModel> {
  //   if ((this.setting)) {
  //     return;
  //   }
  //   return this.api.getFilterEntity<SettingModel>("Setting", 0).pipe(
  //     map((res: SettingModel) => {
  //       this.setting = res;
  //       return this.setting;
  //     }),
  //     catchError((err) => {
  //       return of(null);
  //     }));
  // }
  New_waiterFactor() {
    this.waiterFactor = null;
    this.waiterFactor = [];
    const factor = new FactorModel();
    this.waiterFactor.push(factor);
    this.waiterFactor[0].status = StateEnum.Save;
    this.waiterFactor[0].sourceFlag = SourceProgramEnum.Tablet.toString();
    this.waiterFactor[0].waiterId = this.loginuser.code;
    this.waiterFactor[0].waiterName = this.loginuser.name;
    this.formBuilder = new FormBuilder();
  }
  public getSetting(): Observable<any> {
    this.cache.deleteData('setting');
    if ((this.setting)) {
      return null;
    }
    this.api.getFilterEntity<SettingModel>('Setting', 0).subscribe(res => {
      this.setting = res;
      switch (this.setting.digitalMenuThem) {
        case ThemeEnum.Dark:
          this.setTheme('dark');
          break;
        case ThemeEnum.Light:
          this.setTheme('light');
          break;
        case ThemeEnum.Blue:
          this.setTheme('blue');
          break;
        case ThemeEnum.Orange:
          this.setTheme('orange');
          break;
      }
      this.cache.savePermanentData(this.setting, 'setting');
    });
  }
  getDigitalMenuCount() {
    this.api.getEntity<any>('GetDigitalMenuFactorCount').subscribe((res: Number) => {
      this.digitalmenuFactorCount = res;
    });
  }
  setTheme(theme: string) {
    if (!theme) {
      theme = 'custom';
      this.cache.savePermanentData(theme, 'Theme');
      document.documentElement.classList.add(theme);
    } else {
      let currentTheme: string = this.cache.getData('Theme');
      if (currentTheme) {
        document.documentElement.classList.remove(currentTheme);
      }
      this.cache.savePermanentData(theme, 'Theme');
      document.documentElement.classList.add(theme);
    }
    this.currentTheme = theme;
  }

  ActivateTab(key: any) {
    switch (key) {
      case 0: // index of the tab
        this.router.navigate(['/portal/logo']);
        break;
      case 1:
        this.router.navigate(['/portal/goods']);
        break;
      case 2:
        this.router.navigate(['/portal/slider']);
        break;
      case 3:
          this.router.navigate(['/portal/social']);
        break;
      default:
        this.router.navigate(['/portal']);
        break;
    }
  }

  public reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
    });
  }
}
